import { RefObject } from "react";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNotification, useTranslate } from "@refinedev/core";

import { ModalRef } from "@shared/components";
import { useCreateActivityMutation } from "@modules/activities/services/mutations";
import { ActivityFormValues, activitySchema } from "@modules/activities/validations";

export function useCreateActivityModal(modalRef: RefObject<ModalRef>, onComplete?: () => void) {
  const translate = useTranslate();
  const { open } = useNotification();

  const methods = useForm<ActivityFormValues>({
    resolver: zodResolver(activitySchema()),
    mode: "onBlur",
  });

  const { mutateAsync, isPending } = useCreateActivityMutation({
    onSuccess: () => {
      open?.({
        type: "success",
        message: translate("activity_admin.success.create"),
      });

      modalRef.current?.close();
      onComplete?.();
    },
  });

  return {
    methods,
    mutateAsync,
    isPending,
  };
}
